import * as React from 'react';

import { observer } from 'mobx-react';

import { Body2, Heading3 } from '@estee/elc-typography';

import { SignInType } from '~constants/SignInTypeEnum';
import { SocialButton } from '~views/social-sign-in/SocialButton';

interface IConnectWithSocialProviderProps {
    provider: SignInType;
    title: React.ReactNode;
    content: React.ReactNode;
    buttonLabelKey: string;
    callbackUrl: string;
}

export const ConnectWithSocialProvider = observer(function _ConnectWithSocialProvider({
    provider,
    title,
    content,
    buttonLabelKey,
    callbackUrl
}: IConnectWithSocialProviderProps) {
    const onClick = () => {
        window.open(callbackUrl, '_blank');
    };

    return (
        <>
            <Heading3 className="iam-connect-with-social-provider-title">{title}</Heading3>
            <Body2>{content}</Body2>
            <SocialButton
                onClick={onClick}
                isFormLoading={false}
                labelKey={buttonLabelKey}
                provider={provider}
                buttonStyle="rect"
            />
        </>
    );
});
